import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <p style={styles.code}>404</p>
        <h1 style={styles.title}>ページが見つかりません</h1>
        <p style={styles.text}>
          指定されたURLのページは存在しないか、移動された可能性があります。
        </p>
        <Link to="/" style={styles.link}>
          トップページへ戻る
        </Link>
      </div>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'linear-gradient(180deg, #fffaf0 0%, #f7fafc 100%)',
  },
  card: {
    width: '100%',
    maxWidth: '560px',
    padding: '32px',
    borderRadius: '16px',
    backgroundColor: '#ffffff',
    boxShadow: '0 20px 45px rgba(27, 39, 51, 0.12)',
    textAlign: 'center',
  },
  code: {
    margin: '0 0 8px',
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '0.12em',
    color: '#dd6b20',
  },
  title: {
    margin: '0 0 16px',
    fontSize: '32px',
    color: '#1a202c',
  },
  text: {
    margin: '0 0 24px',
    lineHeight: 1.7,
    color: '#4a5568',
  },
  link: {
    display: 'inline-block',
    padding: '12px 20px',
    borderRadius: '999px',
    backgroundColor: '#2b6cb0',
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 700,
  },
}

export default NotFound
